import type { ISelectOption } from '@sine/sine-ui-components';

import Joi from '../../helpers/joiCommonSchemas';
import type { ISelectOptionVisitorTypesRequirements } from '../../helpers/mapToDropdownOptions';

const SELECT_OPTION_VALIDATION = {
  OPTION_REQUIRED: 'Select an option.',
  ARRAY_OPTION_REQUIRED: 'Select at least one option.',
};

export function singleSelectDropdownOption<ExtraProps>() {
  return Joi.object<ISelectOption & ExtraProps>({
    label: Joi.string().required(),
    value: Joi.alternatives(Joi.string(), Joi.number()).required(),
    description: Joi.string().optional(),
    disabled: Joi.boolean().optional(),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TODO: remove when correct UIC version is installed.
    isFreeText: Joi.boolean().optional(),
    itemRight: Joi.any().optional(),
  }).messages({
    'any.required': SELECT_OPTION_VALIDATION.OPTION_REQUIRED,
    'object.base': SELECT_OPTION_VALIDATION.OPTION_REQUIRED,
  });
}

export const singleSelectDropdownOptionWithDisabled = () =>
  singleSelectDropdownOption().keys({
    disabled: Joi.boolean().optional(),
  });

export const singleSelectDropdownOptionalOption = () =>
  Joi.object<ISelectOption>({
    label: Joi.string(),
    value: Joi.alternatives(Joi.string(), Joi.number()).allow('').optional(),
  });

export const multiSelectDropDownOption = (minimum = 1, itemSchema = singleSelectDropdownOption) =>
  Joi.array().items(itemSchema()).min(minimum).messages({
    'any.required': SELECT_OPTION_VALIDATION.ARRAY_OPTION_REQUIRED,
    'array.empty': SELECT_OPTION_VALIDATION.ARRAY_OPTION_REQUIRED,
    'array.min': SELECT_OPTION_VALIDATION.ARRAY_OPTION_REQUIRED,
  });

export const multiSelectDropDownOptionalOption = Joi.array()
  .items(
    Joi.object().keys({
      label: Joi.string().optional(),
      value: Joi.string().optional(),
    }),
  )
  .optional();

export const singleSelectDropdownOptionWithVtRequirements = () =>
  Joi.object<ISelectOptionVisitorTypesRequirements>({
    label: Joi.string().required(),
    value: Joi.alternatives(Joi.string(), Joi.number()).required(),
    emailRequired: Joi.boolean().required(),
    mobileRequired: Joi.boolean().required(),
    detailsRequired: Joi.boolean().required(),
  }).messages({
    'any.required': SELECT_OPTION_VALIDATION.OPTION_REQUIRED,
    'object.base': SELECT_OPTION_VALIDATION.OPTION_REQUIRED,
  });

export const tagSelectOptionOptional = () =>
  Joi.array()
    .items(
      Joi.object<ISelectOption>({
        label: Joi.string().required(),
        value: Joi.alternatives(Joi.string(), Joi.number()).required(),
        color: Joi.object({
          background: Joi.string(),
          text: Joi.string(),
        }),
      }),
    )
    .optional();
